export enum EditableIssueFields {
  TITLE = 'title',
  DESCRIPTION = 'description',
  SEVERITY = 'severity',
  DUE_DATE = 'dueDate',
  ISSUE_OWNER = 'issueOwner',
  ISSUE_MANAGER = 'issueManager',
  ISSUE_APPROVER = 'issueApprover',
  IMPACTED_ENTITY = 'impactedEntity',
  EXECUTION_TYPE = 'executionType',
  ATTACHMENTS = 'attachments',
  IMPACT = 'impact',
  // Shared Audit Finding & Control Deficiency fields
  CLASSIFICATION = 'classification',
  ROOT_CAUSE = 'rootCause',
  MANAGEMENT_RESPONSE = 'managementResponse',
  RESOLUTION = 'resolution',
  // Audit Finding specific fields
  RECOMMENDATIONS = 'recommendations',
  INCLUDE_IN_AUDIT_REPORT = 'includeInAuditReport',
  REVIEW_STATUS = 'reviewStatus',
  DATE_PUBLISHED = 'datePublished',
  // Control Deficiency specific field
  REMEDIATION = 'remediation',
}
